/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/schEducations/schEducationsActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import { SchEducationEditForm } from "./SchEducationEditForm";
import { useSubheader } from "../../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import { KTUtil } from "../../../../../../_metronic/_assets/js/components/util";
import KTLayoutQuickForm from "../../../../Admin/utils/quick-form";
import { Profile } from "../../profile/Profile";
import axios from "axios";

const initSchEducation = {
  id: undefined,
  scholarId: 0,
  degreeType: "",
  rollNo: "",
  examName: "",
  passingYear: "",
  subjectStudied: "",
  percentage: "",
  university: "",
};
export function SchEducationEdit({
  history,
  match: {
    params: { id,sid },
  },
}) {
  useLayoutEffect(() => {
    KTUtil.ready(function() {
      KTLayoutQuickForm.init("kt_quick_form");
    });
  }, []);
  // Subheader
  const subheader = useSubheader();

  // Tabs
  // const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { actionsLoading, schEducationForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.schEducations.actionsLoading,
      schEducationForEdit: state.schEducations.schEducationForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchSchEducation(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : "New Scholar Education";
    if (schEducationForEdit && id) {
      _title = `Edit  Scholar Education `;
    }

    setTitle(_title);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schEducationForEdit, id]);

  const saveSchEducation = (values) => {
    if (!id) {
      dispatch(actions.createSchEducation(values)).then(() =>
        backToSchEducationsList()
      );
    } else {
      dispatch(actions.updateSchEducation(values)).then(() =>
        backToSchEducationsList()
      );
    }
  };

  const btnRef = useRef();
  const saveSchEducationClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const id1 = id===undefined?'':id
  const ScholarUrl = `${process.env.REACT_APP_API_URL}/api/schEducation/${id1}`;

  const [profile, setProfile] = useState([]);
  useEffect(() => {
    const getScholar = async () => {
      const response = await axios.get(`${ScholarUrl}`);
      setProfile(response.data);
    };
    getScholar();
  }, [setProfile, ScholarUrl]);
  const ScholarId = sid?sid:profile.scholarId;
  
  
  
  initSchEducation.scholarId=ScholarId;



  const backToSchEducationsList = () => {
    history.push(`/scholar/profile`);
  };

  return (
    <div>
      <Profile />
      <div
        id="kt_quick_form"
        className="offcanvas offcanvas-right offcanvas offcanvas-on offcanvas-sm"
      >
        <div className="offcanvas-content pr-5 mr-n5">
          <Card>
            {actionsLoading && <ModalProgressBar />}
            <CardHeader title={title}>
              <CardHeaderToolbar>
                <button
                  type="button"
                  onClick={backToSchEducationsList}
                  className="btn btn-light"
                >
                  <i className="fa fa-times"></i>
                  Close
                </button>
                {/* <button className="btn btn-light ml-2">
                    <i className="fa fa-redo"></i>
                    Reset
                  </button> */}
                <button
                  type="submit"
                  className="btn btn-primary ml-2"
                  onClick={saveSchEducationClick}
                >
                  Save
                </button>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
              {!actionsLoading && (
                <SchEducationEditForm
                  actionsLoading={actionsLoading}
                  schEducation={schEducationForEdit || initSchEducation}
                  btnRef={btnRef}
                  saveSchEducation={saveSchEducation}
                />
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
